import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Downshift from 'downshift'
import PropTypes from 'prop-types'
import { addOrderByMethod, removeOrderByMethod, fetchSearchResultsIfNotBusy } from '../actions/search'
import { colors, fontFamilies } from '../../search-common/settings'
import { media } from '../../search-common/helpers'
import ArrowThinDown from '../icons/ArrowThinDown'
import CheckMark from '../icons/CheckMark'
import { translate } from '../../modules/helper-functions'

const Container = styled.div`
  width: 250px;
  position: relative;
  text-align: center;
  ${media.tablet`
    text-align: right;
  `}
`

const Menu = styled.ul`
  max-height: 200px;
  overflow-y: scroll;
  position: absolute;
  width: 100%;
  border: 1px solid ${colors.grayTone2};
  z-index: 1;
`

const Item = styled.li`
  cursor: pointer;
  font-family: ${fontFamilies.aeonik};
  font-size: 14px;
  padding: 6px;
  font-weight: bold;
  background-color: ${( props ) => props.isSelected || props.isActive ? colors.grayTone1 : colors.black};
  color: ${( props ) => props.isSelected || props.isActive ? colors.highlight : colors.white};

  svg {
    margin-right: 6px;
  }
`

const Button = styled.button`
  font-family: ${fontFamilies.aeonik};
  font-size: 16px;
  font-weight: bold;
  color: ${colors.highlight};
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  cursor: pointer;

  svg {
    height: 11px;
    margin-left: 6px;
  }
`

const Selected = styled.div`
  /* margin-top: 12px; */
`

/**
 * OrderBySelect component.
 */
class OrderBySelect extends Component {
  /**
   * @constructor
   * @param {any} props
   */
  constructor( props ) {
    super( props )

    this.handleChange = this.handleChange.bind( this )
    this.itemToString = this.itemToString.bind( this )
  }

  /**
   * Function handles the component state change
   * by adding or removing the orderby filter.
   *
   * @param {object} option
   */
  handleChange( option ) {
    const { addFilter, removeFilter } = this.props
    if ( option ) {
      addFilter( option )
    } else {
      removeFilter()
    }
    return option
  }

  /**
   * Function returns a string representation
   * of the item.
   *
   * @param {object} item
   * @return {string}
   */
  itemToString( item ) {
    return item ? item.title : ''
  }

  /**
   * Render method.
   */
  render() {
    const { selectedItem, sorting, translations } = this.props
    return (
      <Downshift
        itemToString={this.itemToString}
        onChange={this.handleChange}
        selectedItem={selectedItem}>
        {({
          getRootProps,
          getItemProps,
          getMenuProps,
          isOpen,
          getToggleButtonProps,
          highlightedIndex,
        }) => (
            <Container {...getRootProps()}>
              <Button {...getToggleButtonProps()}>{translate( translations, 'Sort by' )} <ArrowThinDown fill={colors.highlight} /></Button>
              {selectedItem
                ? <Selected>{selectedItem.title}</Selected>
                : null
              }
              {isOpen ?
                <Menu {...getMenuProps()}>
                  {sorting.map(( item, index ) => (
                    <Item
                      key={index}
                      {...getItemProps({
                        item: item,
                        isSelected: selectedItem.title === item.title,
                        isActive: highlightedIndex === index
                      })}
                    >
                      {selectedItem.title === item.title ? <CheckMark fill={colors.highlight} /> : null}
                      {this.itemToString( item )}
                    </Item>
                  ))}
                </Menu>
                : null
              }
            </Container>
          )}
      </Downshift>
    )
  }
}

OrderBySelect.propTypes = {
  sorting: PropTypes.array.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  translations: PropTypes.object.isRequired,
}

/**
 * Map the redux state to component props.
 *
 * @param {object} state
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  sorting: state.search.initial.facets.sorting,
  selectedItem: state.search.orderby,
  translations: state.translations
})

/**
 * Add dispatch functions to components props.
 *
 * @param {function} dispatch
 * @return {object}
 */
const mapDispatchToProps = ( dispatch ) => {
  return {
    addFilter: ( order ) => {
      dispatch( addOrderByMethod( order ))
      dispatch( fetchSearchResultsIfNotBusy())
    },
    removeFilter: () => {
      dispatch( removeOrderByMethod())
      dispatch( fetchSearchResultsIfNotBusy())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)( OrderBySelect )
